import React from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../config/redux/reducers";
import CODPortalBase from "../shared/codPortalBaseComponent";
import CODDriverDetails from "./codDriverDetails";
import CODUploadReceipt from "./codUploadReceipt";
import AppConstants from "../../constants";
import {
  fetchDriversList,
  exportToExcel,
  createReceiptDraft,
  resetExportInitiated,
} from "./redux/codPortalSlice";
import {
  createPayloadToFetchDriversList,
  codPortalDriversDataTransform,
} from "../../mocks/codPortal/response.transforms";

const CODPortal = () => {
  const {
    expDriversData,
    loading,
    expDriversFiltersDropdowns,
    error,
    errorCode,
    excelLoading,
    exportError,
    isAmtCollectedForExpressOrders,
    exportInitiated,
    reportId,
  } = useSelector((state: AppState) => state.codPortal);

  return (
    <CODPortalBase
      reduxStates={{
        driversData: expDriversData,
        loading,
        driversFiltersDropdowns: expDriversFiltersDropdowns,
        error,
        errorCode,
        excelLoading,
        exportError,
        isAmtCollectedForOrders: isAmtCollectedForExpressOrders,
        exportInitiated,
        reportId,
      }}
      transforms={{
        createPayloadToFetchDriversList,
        driversDataTransform: codPortalDriversDataTransform,
      }}
      actions={{
        fetchDriversList,
        exportToExcel,
        createReceiptDraft,
        resetExportInitiated,
      }}
      tableWrapperDataConstant={AppConstants.COD_RECON_CONSTANTS}
      DriverDetails={CODDriverDetails}
      UploadReceipt={CODUploadReceipt}
      moduleName="CODPortal"
    />
  );
};

export default CODPortal;